// Firebase implementation removed - stub functions kept for compatibility

export const generateToken = async (userId) => {
    // No-op: Firebase notification token generation removed
};

export const getNotifications = async (userId) => {
    return [];
};

export const markNotificationAsRead = async (userId, notification) => {
    // No-op: Firebase notification marking removed
};

export const subscribeToNotifications = (userId, callback) => {
    // No-op: Firebase real-time subscription removed
    callback([]);
};